import { HttpResponse } from '@tda/utilities';
import { ProductInfo } from '../domain-models/product-info.model';
import { ChatClient } from './chat-http-client';

export async function fetchProducts(): Promise<HttpResponse<Array<ProductInfo>>> {
  return await ChatClient.get<Array<ProductInfo>>(`/products`);
}
